
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
  CONTRACT_STUDENT_ACTION,
  CONTRACT_ALL_STUDENT,
  CONTRACT_ADD_STUDENT,
  CONTRACT_FETCH_STUDENT,
  CONTRACT_EDIT_STUDENT,
  CONTRACT_DELETE_STUDENT,
  CONTRACT_UPDATE_ENROLMENT,
  CONTRACT_UPDATE_NOTES,
  CONTRACT_PROGRAM_INCLUSION,
  DELETE_PROGRAM_INCLUSION,
  CONTRACT_UPLOAD_DOCUMENT,
  CONTRACT_FETCH_DCOUMENT,
  DELETE_CONTRACT_DOCUMENT,
  ADD_PROGRAM_INCLUSION,
  ADD_AGREEMENT,
  FETCH_AGREEMENT,
  FETCH_AGREEMENT_PROGRAMINCLUSION,
  SEND_AGREEMENT,
  ACCEPT_AGREEMENT,
  EDIT_AGREEMENT,
  DELETE_STUDENT_AGREEMENT,
  CANCEL_STUDENT_AGREEMENT,
  FETCH_PROGRAM_DETAILS,
  ADD_PROGRAM_DETAILS,
  ALL_FINANCIAL_YEAR,
  ALL_AGREEMENT_TYPE,
  ALL_AGREEMENT_FOR,
  ALL_AGREEMENT_PROGRAM,
  ALL_GOLF_PROGRAM,
  PARENT_ALL_CONTRACT,
  PARENT_ALL_DOCUMENT,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';


export const contractAllStudent = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getctstudents', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: CONTRACT_ALL_STUDENT, payload: alldata });
      });
  }

}

export const contractAddStudent = (data) => {
  var payload = {
    studentid: data.target.student.value,
    studentfname: data.target.clsp_1.value,
    studentlname: data.target.smash_1.value,
    parentname: data.target.carry_1.value,
    parentemail: data.target.path_1.value,
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/addctstudents', payload, { headers: AuthHeader.header })
      .then((response) => {
        var resdata = response.data;
        if(resdata.status === 1) {
          contractAllStudent()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_ADD_STUDENT });
        }else{
          NotificationManager.error(resdata.message);
        }
        return Promise.resolve(resdata);
      });
  };
};

export const contractDeleteStudent = (id) => {
  var payload = {
    "id": id
  };
  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/deletectstudents', payload, {
        headers: AuthHeader.header
      })
      .then(response => {
        var resdata = response.data;
        if (resdata.status === 1) {
          contractAllStudent()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_DELETE_STUDENT });
        }
      })
  };
};


export const contractFetchStudent = (id) => async (dispatch) => {

  var payload = {
    "id": id

  }
  dispatch({ type: CONTRACT_STUDENT_ACTION });
  return axios.post(AppConfig.apiurl + '/api/detailsctstudents', payload, { headers: AuthHeader.header })
    .then(response => {
      var resdata = response.data;
      var resvalue = resdata.data;
      dispatch({ type: CONTRACT_FETCH_STUDENT, payload: resvalue });
      return Promise.resolve(resdata);

    })
    .catch(error => {
      const errormsg = error.message
      NotificationManager.error(errormsg);
    });

}

export const contractUpdateEnrolment = (data) => {
  const {
    studentfname,
    studentlname,
    studentemail,
    studentmobile,
    studentdob,
    studentblood,
    studentfood,
    studentfoodallg,
    studentmedical,
    studentinformation,
    parentfname,
    parentlname,
    parentemail,
    parentmobile,
    parentage,
    address,
    parentid,
    exstudentid,
    edcontactid
  } = data;

  const payload = {
    studentfname,
    studentlname,
    studentemail,
    studentmobile,
    studentdob,
    studentblood,
    studentfood,
    studentfoodallg,
    studentmedical,
    studentinformation,
    parentfname,
    parentlname,
    parentemail,
    parentmobile,
    parentage,
    address,
    parentid,
    exstudentid,
    edcontactid
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/editregisterdetails', payload, { headers: AuthHeader.header })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractAllStudent()(dispatch);
          contractFetchStudent(edcontactid)(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_UPDATE_ENROLMENT });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};
export const contractUpdateNotes = (studentid, notes) => {
  const payload = {
    "studentid": studentid,
    notes
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/updatenotes', payload, {
        headers: AuthHeader.header
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractAllStudent()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_UPDATE_NOTES });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};

export const contractProgramInclusion = (id) => async (dispatch) => {
  const payload = {
    id: id
  };

  dispatch({ type: CONTRACT_STUDENT_ACTION });

  try {
    const response = await axios.post(
      'https://portal.tsgacademy.in/Backend/public/api/getagreementpginclusions',
      payload,
      { headers: AuthHeader.header }
    );

    const resdata = response.data;
    const resvalue = resdata.data;

    dispatch({ type: CONTRACT_PROGRAM_INCLUSION, payload: resvalue });

    return Promise.resolve(resdata);
  } catch (error) {
    const errormsg = error.message;
    NotificationManager.error(errormsg);
    return Promise.reject(error);
  }
};

export const contractAddPginc = (studentid, agreementid, programinclusion, ctid) => {
  const payload = {
    pginclstud: studentid,
    pginclagremt: agreementid,
    programinclusion: programinclusion,
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post('https://portal.tsgacademy.in/Backend/public/api/addagreementpginclusions', payload, {
        headers: AuthHeader.header,
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          NotificationManager.success(resdata.message);
          contractFetchStudent(ctid)(dispatch);
          dispatch({ type: ADD_PROGRAM_INCLUSION });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};

export const deleteStudentProgramInclusion = (id, ctid) => {
  var payload = {
    "id": id
  };
  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/deletepginclusions', payload, {
        headers: AuthHeader.header
      })
      .then(response => {
        var resdata = response.data;
        if (resdata.status === 1) {
          contractFetchStudent(ctid)(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: DELETE_PROGRAM_INCLUSION });
        }
      })
  };
};


export const contractUploadDocument = (studentid, description, document, ctid) => {
  const payload = {
    studentid: studentid,
    description: description,
    document: document
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/addstudentctdocument', payload, {
        headers: AuthHeader.header
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractFetchStudent(ctid)(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_UPLOAD_DOCUMENT });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};

export const fetchStudentDocument = (id) => {
  var payload = {
    id: id
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/getstudentctdocument', payload, { headers: AuthHeader.header })
      .then((response) => {
        var resdata = response.data;
        dispatch({ type: CONTRACT_FETCH_DCOUMENT, payload: resdata.data });
        return Promise.resolve(resdata);
      });
  };
};

export const deleteStudentDocument = (id, ctid) => {
  var payload = {
    "id": id
  };
  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/deleteupdocument', payload, {
        headers: AuthHeader.header
      })
      .then(response => {
        var resdata = response.data;
        if (resdata.status === 1) {
          contractFetchStudent(ctid)(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: DELETE_CONTRACT_DOCUMENT });
        }
      })
  };
};

export const deleteStudentAgreement = (id, ctid) => {
  var payload = {
    "id": id
  };
  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/deleteagreement', payload, {
        headers: AuthHeader.header
      })
      .then(response => {
        var resdata = response.data;
        if (resdata.status === 1) {
          contractFetchStudent(ctid)(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: DELETE_STUDENT_AGREEMENT });
        }
      })
  };
};

export const cancelStudentAgreement = (id, ctid) => {
  var payload = {
    "id": id
  };
  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/cancelagreement', payload, {
        headers: AuthHeader.header
      })
      .then(response => {
        var resdata = response.data;
        if (resdata.status === 1) {
          contractFetchStudent(ctid)(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CANCEL_STUDENT_AGREEMENT });
        }
      })
  };
};

export const agreementAllDetails = () => {
 
    return (dispatch) => { 
      dispatch({ type: CONTRACT_STUDENT_ACTION });
      return axios.get(AppConfig.apiurl+'/api/getallagreementdetails', { headers: AuthHeader.header })         
      .then(response => {             
          const alldata=response.data.data;
          const financial=alldata.financial;
          const type=alldata.agreementtype;
          const agrmfor=alldata.agreementfor;
          const program=alldata.program;
          const golfprogram=alldata.golfprogram;
          dispatch({ type: ALL_FINANCIAL_YEAR, payload: financial });
          dispatch({ type: ALL_AGREEMENT_TYPE, payload: type });          
          dispatch({ type: ALL_AGREEMENT_FOR, payload: agrmfor });
          dispatch({ type: ALL_AGREEMENT_PROGRAM, payload: program });
          dispatch({ type: ALL_GOLF_PROGRAM, payload: golfprogram });
      });
    }

}

export const addAgreement = (data) => {
  const {
    financialyear,
    agreementtype,
    agreementstdate,
    agreementenddate,
    agreementextdate,
    program,
    parentage,
    agreementfor,
    parentaddress,
    studentage,
    studentaddress,
    fryear_1,
    frstdate_1,
    frenddate_1,
    frfees_1,
    frtax_1,
    frduedate_1,
    fryear_2,
    frstdate_2,
    frenddate_2,
    frfees_2,
    frtax_2,
    frduedate_2,
    fryear_3,
    frstdate_3,
    frenddate_3,
    frfees_3,
    frtax_3,
    frduedate_3,
    fryear_4,
    frstdate_4,
    frenddate_4,
    frfees_4,
    frtax_4,
    frduedate_4,
    fryear_5,
    frstdate_5,
    frenddate_5,
    frfees_5,
    frtax_5,
    frduedate_5,
    fryear_6,
    frstdate_6,
    frenddate_6,
    frfees_6,
    frtax_6,
    frduedate_6,
    fryear_7,
    frstdate_7,
    frenddate_7,
    frfees_7,
    frtax_7,
    frduedate_7,
    fryear_8,
    frstdate_8,
    frenddate_8,
    frfees_8,
    frtax_8,
    frduedate_8,
    fryear_9,
    frstdate_9,
    frenddate_9,
    frfees_9,
    frtax_9,
    frduedate_9,
    fryear_10,
    frstdate_10,
    frenddate_10,
    frfees_10,
    frtax_10,
    frduedate_10,
    fryear_11,
    frstdate_11,
    frenddate_11,
    frfees_11,
    frtax_11,
    frduedate_11,
    fryear_12,
    frstdate_12,
    frenddate_12,
    frfees_12,
    frtax_12,
    frduedate_12,
    programinclusion,
    student_id,
    contact_id
  } = data;

  const payload = {
    financialyear,
    agreementtype,
    agreementstdate,
    agreementenddate,
    agreementextdate,
    program,
    parentage,
    agreementfor,
    parentaddress,
    studentage,
    studentaddress,
    fryear_1,
    frstdate_1,
    frenddate_1,
    frfees_1,
    frtax_1,
    frduedate_1,
    fryear_2,
    frstdate_2,
    frenddate_2,
    frfees_2,
    frtax_2,
    frduedate_2,
    fryear_3,
    frstdate_3,
    frenddate_3,
    frfees_3,
    frtax_3,
    frduedate_3,
    fryear_4,
    frstdate_4,
    frenddate_4,
    frfees_4,
    frtax_4,
    frduedate_4,
    fryear_5,
    frstdate_5,
    frenddate_5,
    frfees_5,
    frtax_5,
    frduedate_5,
    fryear_6,
    frstdate_6,
    frenddate_6,
    frfees_6,
    frtax_6,
    frduedate_6,
    fryear_7,
    frstdate_7,
    frenddate_7,
    frfees_7,
    frtax_7,
    frduedate_7,
    fryear_8,
    frstdate_8,
    frenddate_8,
    frfees_8,
    frtax_8,
    frduedate_8,
    fryear_9,
    frstdate_9,
    frenddate_9,
    frfees_9,
    frtax_9,
    frduedate_9,
    fryear_10,
    frstdate_10,
    frenddate_10,
    frfees_10,
    frtax_10,
    frduedate_10,
    fryear_11,
    frstdate_11,
    frenddate_11,
    frfees_11,
    frtax_11,
    frduedate_11,
    fryear_12,
    frstdate_12,
    frenddate_12,
    frfees_12,
    frtax_12,
    frduedate_12,
    programinclusion,
    student_id,
    contact_id
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl+'/api/addstudentagreement', payload, {
        headers: AuthHeader.header
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractFetchStudent(contact_id)(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: ADD_AGREEMENT });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};

export const fetchStudentAgreement = (id) => {
  var payload = {
    id: id
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl+'/api/getstudagreementdetails', payload, { headers: AuthHeader.header })
      .then((response) => {
        var resdata = response.data.data;
        var agreement = resdata.agreement;
        var program = resdata.program;
        dispatch({ type: FETCH_AGREEMENT, payload: agreement });
        dispatch({ type: FETCH_AGREEMENT_PROGRAMINCLUSION, payload: program });
        return Promise.resolve(resdata);
      });
  };
};

export const sendStudentAgreement = (id) => {
  const payload = {
    id: id
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/sendagreement', payload, {
        headers: AuthHeader.header
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          NotificationManager.success(resdata.message);
          dispatch({ type: SEND_AGREEMENT });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};

export const acceptStudentAgreement = (id) => {
  const payload = {
    id: id
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/acceptagreement', payload, {
        headers: AuthHeader.header
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          NotificationManager.success(resdata.message);
          dispatch({ type: ACCEPT_AGREEMENT });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};

export const editStudentAgreement = (id, startdate,enddate, excdate, type, ctid) => {
  const payload = {
    edagreement_id: id,
    edpragrtype:type,
    edprstartdate:startdate,
    edprenddate:enddate,
    edprexcudate:excdate,
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/editpragreement', payload, {
        headers: AuthHeader.header
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          NotificationManager.success(resdata.message);
          contractFetchStudent(ctid)(dispatch);
          dispatch({ type: EDIT_AGREEMENT });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};


export const fetchProgramDetails = (id) => async (dispatch) => {

  var payload = {
    "id": id

  }
  dispatch({ type: CONTRACT_STUDENT_ACTION });
  return axios.post(AppConfig.apiurl + '/api/detailsforContractProgram', payload, { headers: AuthHeader.header })
    .then(response => {
      var resdata = response.data;
      var resvalue = resdata.data;
      dispatch({ type: FETCH_PROGRAM_DETAILS, payload: resvalue });
      return Promise.resolve(resdata);

    })
    .catch(error => {
      const errormsg = error.message
      NotificationManager.error(errormsg);
    });

}

export const addProgramDetails = (id, desc, agreement) => {
  const payload = {
    id: id,
    desc: desc,
    agreement: agreement
  };

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/addagreementprogramdetails', payload, {
        headers: AuthHeader.header
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractAllStudent()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: ADD_PROGRAM_DETAILS });
          return Promise.resolve(resdata);
        } else {
          NotificationManager.error(resdata.message);
          return Promise.reject(resdata);
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message || 'An error occurred');
        return Promise.reject(error);
      });
  };
};

export const parentViewAgreement = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getstudagreement', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: PARENT_ALL_CONTRACT, payload: alldata });
      });
  }

}

export const parentViewDocument = () => {

  return (dispatch) => {
    dispatch({ type: CONTRACT_STUDENT_ACTION });
    return axios.get(AppConfig.apiurl + '/api/getstuddocuments', { headers: AuthHeader.header })
      .then(response => {
        const alldata = response.data.data;
        dispatch({ type: PARENT_ALL_DOCUMENT, payload: alldata });
      });
  }

}